/**
 * @generated SignedSource<<6af4de1cb4476df0f0ad6082e4163862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountUserInvitationFragment$data = {
  readonly createdAt: any | null;
  readonly email: string;
  readonly externalId: string;
  readonly id: string;
  readonly " $fragmentType": "accountUserInvitationFragment";
};
export type accountUserInvitationFragment$key = {
  readonly " $data"?: accountUserInvitationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountUserInvitationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountUserInvitationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "AccountUserInvitation",
  "abstractKey": null
};

(node as any).hash = "a9a022d7afff42edbf60cb2af0a47333";

export default node;
